import {createApp} from 'vue'
import App from './App.vue'
import './assets/scss/main.scss'
import VLSession from "./components/js/VLSession"

const app = createApp(App)
app.use(VLSession)
app.mount('#app')
